import { getFirebaseApp } from '../utils/firebase.js';
import { initializeFirestore, connectFirestoreEmulator } from 'firebase/firestore';
import bowser from '../utils/bowser.js';

let firestore;

function firestore$1 () {
  if (!firestore) {
    const firebaseApp = getFirebaseApp();
    const settings = {
      experimentalForceLongPolling:
        bowser.osName === "ios" ||
        bowser.osName === "macos" ||
        (typeof window !== "undefined" && window.Cypress)
    };
    firestore = initializeFirestore(firebaseApp, settings);

    if (import.meta.env.VITE_NODE_ENV === "development") {
      const port = import.meta.env.VITE_FIRESTORE_EMULATOR_PORT || "8080";
      connectFirestoreEmulator(firestore, "127.0.0.1", Number(port));
    }
  }

  return firestore;
}

export { firestore$1 as default };
